module.exports = __webpack_public_path__ + "img/hw-s6.c502f743.svg";